import Breakdancer from 'breakdancer';

/**
 * Our breakpoint specifications. The key represents the name of the breakpoint
 * and the object specifies the specification in order to trigger the break
 * point. These breakpoints follow the design specification from our
 * invisionapp.
 *
 * Please note that the values in the breakdancer represent the minimum values
 * so need to + 1 the design specification in order to get an exact match.
 *
 * @type {Breakdance}
 * @public
 */
const breakpoints = new Breakdancer([
  {
    name: 'mobile',
    width: 519 + 1
  },

  {
    name: 'phablet',
    width: 767 + 1
  },

  {
    name: 'tablet',
    width: 991 + 1
  },

  {
    name: 'desktop',
    width: 1199 + 1
  },

  {
    name: 'large',
    width: 1719 + 1
  },
  //
  // Last capture all the things query.
  //
  {
    name: 'xlarge',
    width: Infinity
  }
]);

export default breakpoints;
